import { cva } from 'class-variance-authority';

export const pricingPlanTitleStyle = cva('flex flex-col text-left font-spaceGrotesk text-display-xs font-semibold', {
  variants: {
    isHighlighted: {
      true: 'bg-textHighlightGradient bg-clip-text text-transparent',
      false: 'text-white',
    },
  },
});

export const contentRowStyle = cva(['flex items-center border-t border-t-white/20 bg-white/5 px-3 py-4'], {
  variants: {
    isText: {
      true: 'flex-row',
      false: 'flex-row',
    },
  },
});
